import React from 'react';

const SuccessIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='92' height='92' viewBox='0 0 92 92'>
      <g fill='none' fillRule='evenodd'>
        <g fill='var(--theme-primary, #810ea9)' fillRule='nonzero'>
          <g>
            <path
              d='M46 0c1.657 0 3 1.343 3 3s-1.343 3-3 3C24.13 6 6.359 23.552 6.005 45.339L6 45.996C6.029 68.098 23.954 86 46.065 86c3.083.008 6.155-.36 9.18-1.106C73.268 80.656 86.005 64.572 86 46.057c0-1.657 1.342-3 3-3 1.656-.001 3 1.342 3 2.999.005 21.3-14.647 39.803-35.35 44.672-3.469.854-7.03 1.282-10.594 1.272C20.644 92 .033 71.417 0 46.004v-.008l.006-.757C.412 20.185 20.85 0 46 0zm35.12 17.877c1.125 1.124 1.172 2.919.138 4.098l-.135.144-37.933 38c-1.125 1.128-2.923 1.173-4.102.136l-.144-.136-12.067-12.088c-1.17-1.173-1.17-3.072.004-4.243 1.125-1.123 2.92-1.167 4.098-.13l.144.134 9.943 9.961 35.81-35.872c1.171-1.173 3.07-1.175 4.243-.004z'
              transform='translate(-4 -4) translate(4 4)'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SuccessIcon;
